import React from 'react';
import styles from './PageBody.module.css';

export default function PageBody({...props }: any) {

  return (
    <div className={`${styles.pageBody}`}>
        {props.children}
    </div>
  );
}